import TagManager from 'react-gtm-module';

export const gtm = (args: any) => {
  TagManager.dataLayer({
    dataLayer: {
      args,
    },
  });
};
